import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';

import { Select, Textarea, MultiSelect } from '../../../itrust_common/components/form'
import { SaveButton } from '../../../itrust_common/components/others';
import { STATUSES } from '../../../itrust_common/components/Constants';
import PatientInfo from './PatientInfo'
import { humanize } from '../../../itrust_common/components/HelperFunctions';
import AppointmentStartEndTime from './AppointmentStartEndTime';
import TabAppointment from './TabAppointment';

class AppointmentForm extends Component {

  async handleStatusChange(status) {
    const { appointment, handleDelete } = this.props;
    if (status === 'cancelled') {
      handleDelete(appointment.id);
    }
  }

  renderAppointmentCheckInStatus(status, appointmentStatus) {
    switch (status) {
      case "Early":
        return <span className="badge rounded background-lime-green text-white">{appointmentStatus}</span>
      case "Late":
        return <span className="badge rounded background-dark-green text-white">{appointmentStatus}</span>
      case "On Time":
        return <span className="badge rounded check-in-on-time text-white">{appointmentStatus}</span>
      default:
    }
  }

  render() {
    const { appointment, staffs, handleSubmit, handleAppointmentEditHandler, patient, handleDelete, handleAppointmentReconfirm, procedures, saving, isFullMode, handleAppointmentEditCancel } = this.props

    const updateAppointmentStatuses = [
      ...STATUSES,
      { value: 'cancelled', text: 'Cancelled' },
      { value: 'no_show', text: 'No Show' }
    ]
    return (
      <>
        <form onSubmit={handleSubmit}>
          {isFullMode && <div className="p-5 d-flex flex-row align-items-center justify-content-between border-bottom border-bottom-2 border-light">
            <h5>Appointment Details</h5>
            <div className='d-flex align-items-center'>
              <button type="button" className="btn btn-outline-primary" onClick={handleAppointmentEditCancel}>Cancel</button>
              <SaveButton wrapperClasses="ml-4" buttonClasses={`${!patient.id && 'disabled'}`} saving={saving} />
            </div>
          </div>}
          <div className={`${isFullMode && 'overflow-auto overflow-x-hidden full-mode-appointment-modal'}`}>
            <div className="modal-body px-5 pt-5 pb-0">
              <TabAppointment staffs={staffs} tab_appointment={appointment.tab_appointment} />
              <AppointmentStartEndTime procedures={procedures} />
              <PatientInfo patient={patient} />
            </div>
            <div className="row w-100 m-0 px-5">
              <MultiSelect key={`appointment-${appointment.id}-procedures`} name="procedure_ids"
                placeholder="Reason For Visit *"
                data={procedures}
                defaultValues={appointment.procedure_ids}
                textField="friendly_name"
                valueField="settings_procedure_id"
                isAllSelectVisible={false}
                isSearchVisible={true}
                onSelectHook={(value) => { this.props.dispatch(change('appointmentForm', 'procedure_ids', value)) }}
                wrapperClasses="col-12 form-group px-0"
              />
              <Field name="comment" rows={1} component={Textarea} label="Comments" className="form-control" wrapperClasses="col-12 form-group px-0" />
              {(appointment.status === "checked_in" || appointment.status === "complete") ?
                <div className='d-flex flex-column'>
                  <span>Status</span>
                  <span className='mb-5'>
                    {appointment.status === "checked_in" ?
                      <>
                        <span className='mx-2'>Appointment Checked in:</span>
                        {this.renderAppointmentCheckInStatus(appointment.check_in_type, appointment.last_status)}
                      </> :
                      <span className="badge badge-pill background-lime-green">{humanize(appointment.status)}</span>
                    }
                  </span>
                </div> :
                <Field label="Status" name="status" component={Select} textField="text" valueField="value" data={updateAppointmentStatuses} wrapperClasses="col-12 form-group px-0" onChange={(e) => this.handleStatusChange(e?.target?.value)} />
              }
            </div>
            {isFullMode && <div className="modal-footer px-5 pb-7 pt-0 border-0">
              {appointment.id &&
                <div className="dropdown">
                  <button type="button" className="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown">
                    More Options
                  </button>
                  <div className="dropdown-menu py-1 border-0 rounded shadow">
                    <a className="dropdown-item pointer"
                      onClick={() => { handleAppointmentEditHandler({ isFullMode: true }); }}>
                      Full mode
                    </a>
                    <a className="dropdown-item" onClick={() => handleAppointmentReconfirm(appointment.id)}>Reconfirm</a>
                    <a className="dropdown-item pointer" onClick={() => handleDelete(appointment.id)}>Cancel</a>
                  </div>
                </div>
              }
              {/* <SaveButton buttonClasses={`${!patient.id && 'disabled'}`} saving={saving} /> */}
            </div>}
          </div>
        </form>
      </>
    );
  }

}

AppointmentForm = reduxForm({
  form: 'appointmentForm',
  enableReinitialize: true
})(AppointmentForm)

AppointmentForm = connect(state => {
  const { currentStore, appointment } = state
  return {
    staffs: currentStore.staffs,
    appointment: appointment.appointment,
    initialValues: {
      ...appointment.appointment
    }
  }
})(AppointmentForm)

export default AppointmentForm;